import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import { Grid, cls, HeaderCompound, Row, Column, Heading, Button } from '../../packages/components';
import Asset from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import { playFullMedia } from '../../actions/playmedia';
import { DETAIl_S } from '../../payments/utils/constants';
import { AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import LayersControl from '../../utils/LayersControl';
import * as PlanSelectorUtils from '../../payments/PlanSelector/PlanSelectorUtils';
import { getProductTypes } from '../../payments/PlanSelector/PSUtils';
import { getTransactionalLabels } from '../../payments/utils/Utils';
import { PlanSelector } from '../../packages/components/lib/PlanSelector';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import { getAndroidTvPolicesLabels, getAddonAndroidMessageClassNames } from '../../payments/utils/Utils';
import { GA4 } from 'src/utils/trackers/GA4';
import { CONTENT_TYPE_TV, CONTENT_SECTION_START, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, CONTENT_SECTION_PLAYER_TV, DOES_NOT_APPLY } from 'src/utils/trackers/GA4Constants';
import './styles/modalAddOn.scss';
import { getTransactionalPrice, getTransactionalTax, getTransactionalBonus } from '../../payments/utils/Utils';
import { TRANSACTION_COMPONENT_UPSELL } from '../../payments/utils/constants';
import { shouldMetadataInfoShowed } from 'src/utils/Utils';

const MAIN_CLASSNAME = 'modal-add-on';
const AAF_FLOW_CALL_CENTER = 'FLOW_CALL_CENTER';
const AAF_FLOW_ADDON = 'AAF_FLOW_ADDON';
const AAF_FLOW_PACKAGE = 'AAF_FLOW_PACKAGE';
const AAF_FLOW_GOOLE_POLICITY_ANDROID_TV = 'AAF_GOOLE_POLICITY_ANDROID_TV';
const MAIN_CALLCENTER_CLASSNAME = 'aaf_app_modal-call-center';

const shouldShowAndroidMessage = (buttons) => {
    return UtilsPagos.shouldShowAndroidMessage(buttons);
}

const getAddonAndroidMessage = (buttons, labels) => {
    if (shouldShowAndroidMessage(buttons)) {
        const classes = {
            classNameContainer: `${MAIN_CLASSNAME}-upsell-android-tv-policies`,
            classNameTitle: 'title-android-tv',
            classNameDescription: 'description-android-tv'
        };
        return getAddonAndroidMessageClassNames(labels, classes);
    }
    else {
        return null;
    }
}

const getTypeOffer = (pbi) => {
    const { listButtons: { button = [] } = {} } = pbi || {};
    const quantity = getQuantityVisibleParam(button);
    if (quantity === 1) {
        // EL FLUJO ES POR ADDON
        return AAF_FLOW_ADDON;
    } else if (quantity > 1) {
        // EL FLUJO ES POR PAQUETES
        return AAF_FLOW_PACKAGE;
    } if (shouldShowAndroidMessage(button)) {
        // EL FLUJO SOLO PARA POLITICAS DE GOOGLE (SOLO DISPOSITIVOS ANDROID TV)
        return AAF_FLOW_GOOLE_POLICITY_ANDROID_TV;
    } else {
        // EL FLUJO ES POR CALL CENTER
        return AAF_FLOW_CALL_CENTER
    }
}

const getQuantityVisibleParam = (buttons) => {
    let result = 0;
    if (buttons && Array.isArray(buttons)) {
        const findVisibles = buttons.filter((obj) => {
            if (obj.hasOwnProperty("purchasable")) {
                return obj.purchasable == true
            }
            else return false;
        });
        if (findVisibles && Array.isArray(findVisibles)) {
            result = findVisibles.length
        }
    }
    return result;
}

const getVisiblePlan = (pbi, userLoggedIn = false) => {
    let visiblePlan = {};
    const { listButtons: { button = [] } = {} } = pbi || {};
    if (Array.isArray(button)) {
        const firstButtonArray = button.filter((obj) => {
            if (obj.hasOwnProperty("visible")) {
                return obj.visible == true
            }
            else return true;
        });
        visiblePlan = firstButtonArray[0] || {};
        if (Object.keys(visiblePlan).length > 0) {
            visiblePlan.fromsusctv = userLoggedIn ? 'susctvregistrado' : 'susctvanonimo'; // Para back desde payment
        }
    }
    return visiblePlan;
}

const getFirstPlan = pbi => {
    const { listButtons: { button: [firstPlan = {}] = [] } = {} } = pbi || {};
    return firstPlan;
}

const getFamily = (pbi, provider) => {
    const { listButtons: { button: [firstButton = {}] = [] } = {} } = pbi || {};
    const { family = provider } = firstButton || {};
    return family;
}

const getOfferId = (pbi) => {
    const { listButtons: { button: [firstButton = {}] = [] } = {} } = pbi || {};
    const { offerid } = firstButton || {};
    return offerid;
}

const getIncludes = (pbi, family) => {
    const { listButtons: { button: [firstButton = {}] = [] } = {} } = pbi || {};
    const { includes = `includes_${family}` } = firstButton || {};
    return includes;
}

const getBonus = firstVisiblePlan => {
    const { bonus = '', producttype, family, offerid } = firstVisiblePlan || {};
    const metadataBonus = {};
    const upsellBonus = getTransactionalBonus({
        component: TRANSACTION_COMPONENT_UPSELL,
        bonus,
        producttype,
        family,
        offerid
    });

    if (shouldMetadataInfoShowed()) {
        metadataBonus['data-metadata-key'] = `${upsellBonus.key}`;
    }
    return <span {...metadataBonus}>
        {upsellBonus.label}
    </span>
}

const getProviderLogo = family => {
    let providerLogo = Asset.get(`${family}_subscription_logo`, '');
    if (!providerLogo) {
        providerLogo = Asset.get(`transactional_${family}_logo`);
    }
    return providerLogo
}

const getCallCenterNumber = (plan, family) => {
    const { offerid = '' } = plan || {}
    let number = Translator.get(`${offerid}_subscription_modal_number_callCenter_label`, '')
    if (!number) {
        number = Translator.get(`${family}_subscription_modal_number_callCenter_label`)
    }
    return number;
}

const renderPrice = firstVisiblePlan => {
    const { currency = '', price = '', periodicity = '', producttype, oneoffertype, frequency } = firstVisiblePlan || {};
    const metadataPrice = {}, metadataTax = {};
    const upsellPrice = getTransactionalPrice({
        component: TRANSACTION_COMPONENT_UPSELL,
        currency,
        price,
    });
    const upsellTax = getTransactionalTax({
        component: TRANSACTION_COMPONENT_UPSELL,
        producttype,
        periodicity,
        oneoffertype,
        frequency,
    })
    if (shouldMetadataInfoShowed()) {
        metadataPrice['data-metadata-key'] = `${upsellPrice.key}`;
        metadataTax['data-metadata-key'] = `${upsellTax.key}`;
    }

    return (
        <Heading size={1} className={cls(`${DETAIl_S}-heading-bottom`)}>
            <span {...metadataPrice}>
                {upsellPrice.label}
            </span>
            &nbsp;
            <span {...metadataTax} className="tax">
                {upsellPrice.label ? upsellTax.label : ""}
            </span>
        </Heading>
    )
}

const Title = ({ isPackageFlow }) => {
    return (
        <Column lg={12}>
            <p className={cls(`${MAIN_CLASSNAME}-title`, { "package-title": isPackageFlow })}>
                {Translator.get('subscription_modal_title_label', 'Para poder acceder a este canal, contratá:')}
            </p>
        </Column>
    )
}

const validFamily = (button, provider, key) => {

    if (!button) return Translator.get(key, key);

    const buttonNotPurchaseable = button.find((b) => {
        return !b.hasOwnProperty('purchasable') || b.purchasable === false;
    });

    const { family = '', offerid = '' } = buttonNotPurchaseable || {};

    if (Translator.get(`${family}_${key}`) !== `${family}_${key}`) {
        return Translator.get(`${family}_${key}`);
    }
    if (Translator.get(`${offerid}_${key}`) !== `${offerid}_${key}`) {
        return Translator.get(`${offerid}_${key}`);
    }
    if (Translator.get(`${provider}_${key}`) !== `${provider}_${key}`) {
        return Translator.get(`${provider}_${key}`);
    }

    return Translator.get(key, key)

}

const ProviderLogo = ({ src }) => {
    return (
        <Column lg={12} className={cls(`${DETAIl_S}-logo-image`)}>
            <div style={{ backgroundImage: `url(${src})` }} className={cls(`${DETAIl_S}-first-logo-bg`)} />
        </Column>
    )
}

const CallCenterDetails = ({ plan, family }) => {
    return (
        <Column lg={12} className={`${MAIN_CLASSNAME}-call-center-details`}>
            <p className={cls(`${MAIN_CLASSNAME}-title-call-center`, `${MAIN_CLASSNAME}-padding-top-3`, `${MAIN_CLASSNAME}-bold`)}>
                {Translator.get('subscription_modal_title_callCenter_label', 'CONTRATA ESTE CANAL')}
            </p>
            <p className={cls(`${MAIN_CLASSNAME}-description-call-center`, `${MAIN_CLASSNAME}-padding-top-1`)}>
                {Translator.get('subscription_modal_description_callCenter_label', 'LLamando a centro de atención')}
            </p>
            <p className={cls(`${MAIN_CLASSNAME}-description-call-center`, `${MAIN_CLASSNAME}-padding-top-1`, `${MAIN_CLASSNAME}-bold`)}>
                {getCallCenterNumber(plan, family)}
            </p>
        </Column>
    );
}

const AndroidTvPolicity = ({ buttons, labels }) => {
    return (
        <Column lg={12} className={`${MAIN_CLASSNAME}-android-tv-policies-wrapper`}>
            {getAddonAndroidMessage(buttons, labels)}
        </Column>
    );
}

const PlanSelectorComponent = ({cardData, handleBlueButton}) =>{

    return (
        <Row>
            <Column lg={12} className={`${MAIN_CLASSNAME}-package`}>
                <PlanSelector cardData={cardData} onBlueButton={handleBlueButton} subscription />
            </Column>
        </Row>
    )
}

const TitleCallCenter = ({ props }) => {

    const { button, provider } = props || {};

    return (
        <Column lg={12}>
            <p className={cls(`${MAIN_CALLCENTER_CLASSNAME} title`)}>
                {Translator.get(validFamily(button, provider, 'subscription_modal_title_OfferCallCenter_label'))}
            </p>
        </Column>
    )
}
const OneText = ({ props }) => {

    const { button, provider } = props || {};

    return (
        <Column lg={12} className={cls(`${MAIN_CALLCENTER_CLASSNAME} botton-1`)}>
            <Row className={cls(`${MAIN_CALLCENTER_CLASSNAME} OneText`)}>
                {Translator.get(validFamily(button, provider, 'subscription_modal_description_OfferCallCenter_label'))}
            </Row>
        </Column>
    )
}

const MiddleText = ({ props }) => {

    const { button, provider } = props || {};

    return (
        <Column lg={12} className={cls(`${MAIN_CALLCENTER_CLASSNAME} botton-2`)}>
            <Row className={cls(`${MAIN_CALLCENTER_CLASSNAME} MiddleText`)}>
                {Translator.get(validFamily(button, provider, 'subscription_modal_titleNumber_OfferCallCenter_label'))}
            </Row>
            <Row className={cls(`${MAIN_CALLCENTER_CLASSNAME} MiddleNumber`)}>
                {Translator.get(validFamily(button, provider, 'subscription_modal_number_OfferCallCenter_label'))}
            </Row>
        </Column>
    )
}

const BottonText = ({ props }) => {

    const { button, provider } = props || {};

    return (
        <Column lg={12} className={cls(`${MAIN_CALLCENTER_CLASSNAME} botton-3`)}>
            <Row className={cls(`${MAIN_CALLCENTER_CLASSNAME} BottonText`)}>
                {Translator.get(validFamily(button, provider, 'subscription_modal_note_OfferCallCenter_label'))}
            </Row>
        </Column>
    )
}

const BodyCallCenter = ({ props }) => {
    const { pbi, provider } = props;
    const { listButtons: { button = [] } = {} } = pbi || {};


    return (
        <div className={cls(`${MAIN_CALLCENTER_CLASSNAME} call-center-main-container`)}>
            <Row>
                <TitleCallCenter props={{ button, provider }} />
            </Row>
            <Row>
                <OneText props={{ button, provider }} />
            </Row>
            <Row>
                <MiddleText props={{ button, provider }} />
            </Row>
            <Row>
                <BottonText props={{ button, provider }} />
            </Row>
            <Row>
                <Button
                    activate
                    id="callcenterbutton"
                    type="button"
                    variant="primary"
                    className={cls('focusable', `${MAIN_CALLCENTER_CLASSNAME} button`)}
                    onClick={(e) => {
                        props.handleClose(e, props.backCallback);
                    }}

                >
                    {Translator.get(
                        'subscription_modal_option_button_close'
                    )}
                </Button>
            </Row>
        </div>
    );
};


class ModalAddOn extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            cardData: []
        }

        const { pbi = {}, provider, groupId, history = null, user = {}, playFullMedia = () => { }, backCallback = () => { }, handleClose = () => { }, data } = props || {};

        this.history = history;
        this.callCenterProps = {
            pbi,
            provider,
            groupId,
            backCallback,
            handleClose,
            data

        }
        this.modalProps = {
            childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
            yellowAction: (e) => {
                e && (typeof e.preventDefault === 'function') && e.preventDefault();
                e && (typeof e.stopPropagation === 'function') && e.stopPropagation();
                handleClose(e, backCallback)
            }, callblueWhenBlue: (e) => {
                const eventId = e && e.target && e.target.id;
                if (eventId) {
                    this.handleBlueButton(eventId);
                }
            },
            callbackWhenBack: () => { backCallback() }
        };
        this.family = getFamily(pbi, provider);
        this.offerid = getOfferId(pbi);
        this.includes = getIncludes(pbi, this.family);
        this.providerLogo = getProviderLogo(this.family);
        this.pbi = pbi;
        this.handleClose = handleClose;
        this.backCallback = backCallback;
        //* Ejemplo nueva key: ContratacionCanal_Transaccion_TextoDescripcion_{family|offerId|proveedor.codigo}
        const keyOne = Translator.get(`ContratacionCanal_Transaccion_TextoDescripcion_${this.family}`, '');
        const keyTwo = Translator.get(`ContratacionCanal_Transaccion_TextoDescripcion_${this.offerid}`, '');
        const keyThree = Translator.get(`ContratacionCanal_Transaccion_TextoDescripcion_${provider}`, '');
        const multiKeyDescription = keyOne !== '' ? keyOne : keyTwo !== '' ? keyTwo : keyThree;
        this.description = multiKeyDescription;
        this.userLoggedIn = user.isAnonymous === false;
        // Variable que indica si es flujo de call-center, addon o paquete de canales
        this.typeFlow = getTypeOffer(pbi);
        this.isPackageFlow = this.typeFlow === AAF_FLOW_PACKAGE;
        this.plan = this.typeFlow === AAF_FLOW_CALL_CENTER ? getFirstPlan(pbi) : getVisiblePlan(pbi, this.userLoggedIn);
        this.hasPlan = this.isPackageFlow ? false : Object.keys(this.plan).length > 0;
        const { listButtons: { button = [] } = {} } = pbi || {};
        this.button = button;
        this.labels = getTransactionalLabels();
        this.details = this.button
            ? PlanSelectorUtils.parseDetailPlan(this.button, this.labels)
            : [];
        const detail = this.details.find((detail) => detail.id === this.offerid);
        this.detail = detail
        this.activePlan = this.button.length < 1 ? {
            // Objeto genérico para contenido sin PBI. Se toma el atributo provider como family
            id: groupId,
            providerLogo: getProviderLogo(provider),
            pbi: {
                family: provider,
            },
            buttons: []
        } : {
                ...PlanSelectorUtils.parsePlan(this.plan, null, this.labels),
                ...detail,
            };
    }

    focusOnFirstActionButton = () => {
        if (this.isPackageFlow) {
            window.SpatialNavigation.focus(`.aaf_plan-selector .focusable`);
        }
        else {
            window.SpatialNavigation.focus(`.${MAIN_CLASSNAME}-actions .focusable`);
        }
    }
    closeModalAndShowUX = () => {
        this.handleClose();
        LayersControl.showUX();
    }

    renderButtons = (data) => {
        const {groupId} = this.props || {};

        const whatIncludesButtonText = Translator.get(this.includes, '');
        const whatIncludesButton = {
            text: whatIncludesButtonText ? whatIncludesButtonText : Translator.get('subscription_modal_option_button_subscriptionDescription'),
            onClick: () => {
                this.props.playFullMedia({
                    playerstate: AAFPLAYER_STOP,
                    source: null,
                    ispreview: false,
                    islive: true,
                    ispip: false,
                    event: null
                });
                this.closeModalAndShowUX();
                this.sendStartCheckoutEvent(this.activePlan, data)
                this.history.push(
                    `/detailSelector`,
                    {
                        activePlan: this.activePlan,
                        provider: this.provider,
                        metricsHistoryAddon: false
                    }
                );
            },
            className: `${MAIN_CLASSNAME}-info-button`
        };
        let subscribeText;
        if (this.offerid) {
            subscribeText = Translator.get(`${this.offerid}_subscription_modal_option_button_checkout`, '')
        }
        if (!subscribeText) {
            subscribeText = Translator.get('subscription_modal_option_button_checkout', 'CONTRATAR');
        }
        const subscribeButton = {
            text: subscribeText,
            onClick: () => {
                this.props.playFullMedia({
                    playerstate: AAFPLAYER_STOP,
                    source: null,
                    ispreview: false,
                    islive: true,
                    ispip: false,
                    event: null
                });
                this.closeModalAndShowUX();
                this.sendStartCheckoutEvent(this.activePlan, data);
                if (this.userLoggedIn) {
                    this.history.push('/detailtransaction', { ...this.plan, groupId, islive: true, metricsHistory: 'tv' });
                } else {
                    this.history.push(`/register`);
                }
            },
            className: `${MAIN_CLASSNAME}-checkout-button`
        };
        const cancelButton = {
            text: Translator.get('subscription_modal_option_button_cancel', 'CANCELAR'),
            onClick: (e) => {
                this.handleClose(e, this.backCallback);
            },
            className: `${MAIN_CLASSNAME}-cancel-button`
        };
        const buttons = [];
        buttons.push(whatIncludesButton);
        if (this.hasPlan && this.typeFlow === AAF_FLOW_ADDON) {
            buttons.push(subscribeButton);
        }
        buttons.push(cancelButton);
        return (
            buttons.map(button => {
                const { text = '', onClick = () => { }, className = '' } = button;
                return (
                    <Column lg={12} className={cls(`${MAIN_CLASSNAME}-button-wrapper`)}>
                        <Button className={cls('focusable', `${MAIN_CLASSNAME}-button`, className)} onClick={onClick}>
                            {text}
                        </Button>
                    </Column>
                );
            })
        )
    }


    handleBlueButton = (offerid) => {
        const { provider, groupId } = this.props;
        if (this.typeFlow === AAF_FLOW_PACKAGE) {
            this.props.playFullMedia({
                playerstate: AAFPLAYER_STOP,
                source: null,
                ispreview: false,
                islive: true,
                ispip: false,
                event: null
            });

            const plan = this.button.find((plan) => plan.offerid === offerid);
            const detail = this.details.find((detail) => detail.id === offerid);
            const activePlan = {
                ...PlanSelectorUtils.parsePlan(plan, null, this.labels),
                ...detail
            }
            this.closeModalAndShowUX();
            this.history.push('/detailSelector', { activePlan, provider, islive: true, groupId, metricsHistoryAddon: false });
        }
    }

    sendGA4Metric = (pbi, event) => {
        const { offerid, price, producttype, frequency, family } = pbi;
        const ga4 = new GA4();
        const id = offerid;
        const name = producttype;
        const category = CONTENT_TYPE_TV;
        const category2 = DOES_NOT_APPLY;
        const category3 = CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION;
        const category4 = DOES_NOT_APPLY;
        const brand = family;
        const list_name = CONTENT_SECTION_START;
        const quantity = frequency;
        ga4.sendPlanSelectorEvent(id, name, category, category2, category3, category4, brand, list_name, price || '0.00', quantity);
    }

    sendStartCheckoutEvent = (plan, data) => {
        const ga4 = new GA4();
        const { name, dvb_content } = data
        const { id, pbi } = plan;
        const { price, family } = pbi;

        const category = CONTENT_TYPE_TV;
        const category2 = DOES_NOT_APPLY;
        const category3 = CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION;
        const category4 = DOES_NOT_APPLY;
        const brand = family;
        const list_name = CONTENT_SECTION_PLAYER_TV;

        ga4.sendStartCheckoutEvent(id, name, category, category2, category3, category4, brand, list_name, price, 1);

    }

    renderPackage = async (data) => {
        const { groupId } = this.props;
        this.setState({isFetching: true})
        const { listButtons: { button = [] } = {} } = this.pbi || {};
        const handlePlanClick = (planClicked) => {
            this.sendGA4Metric(planClicked, data)
            this.closeModalAndShowUX();
            this.props.playFullMedia({
                playerstate: AAFPLAYER_STOP,
                source: null,
                ispreview: false,
                islive: true,
                ispip: false,
                event: null
            });
            this.history.push(`/detailtransaction`, { ...planClicked, islive: true, groupId, metricsHistory: 'tv' });
        }
        const plan = PlanSelectorUtils.parsePlans(button, handlePlanClick, getTransactionalLabels(), true);
        const cardData = await getProductTypes(plan);
        this.setState({cardData: cardData.cardData, isFetching: false});
    }

    componentDidMount() {

        const { data } = this.props || {};
        this.typeFlow === AAF_FLOW_PACKAGE && this.renderPackage(data)

        setTimeout(() => {
            this.typeFlow !== AAF_FLOW_CALL_CENTER && this.focusOnFirstActionButton();
        }, 100);
    }

    render() {

        const {cardData, isFetching} = this.state;
        const {backCallback = () => { }, handleClose = () => { }, data } = this.props || {};

        if (this.typeFlow === AAF_FLOW_CALL_CENTER) {
            const _modalProps = this.modalProps;
            _modalProps.showLogo = true;
            _modalProps.aafNewStyle = true;
            _modalProps.colorButtons = [
                {
                    content: Translator.get('top_head_option_button_return', 'REGRESAR'),
                    props: {
                        color: 'yellow',
                        className: 'modal-button-return',
                        imgSrc: Asset.get('top_head_option_back', ''),
                        onClick: (e) => { handleClose(e, backCallback) },
                    },
                },
            ];

            _modalProps.onOpen = () => window.SpatialNavigation.focus('#callcenterbutton');

            return (
                <ModalWrapper className='aaf_app_modal-call-center' {..._modalProps}>
                    <Grid className={MAIN_CALLCENTER_CLASSNAME}>
                        <HeaderCompound
                            disabled
                            align='right'
                        />
                        <Row>
                            <BodyCallCenter props={this.callCenterProps} />
                        </Row>
                    </Grid>
                </ModalWrapper>
            )
        }
        else {
            return (
                <ModalWrapper {...this.modalProps}>
                    <Grid className={MAIN_CLASSNAME}>
                        <div>
                            <HeaderCompound
                                disabled
                                // align='right'
                                onClick={(e) => { handleClose(e, backCallback) }}
                                textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                                icon={`${Asset.get('top_head_option_back')}`} />
                            <Row>
                                <Title isPackageFlow={this.isPackageFlow} />
                                {this.typeFlow !== AAF_FLOW_PACKAGE && <ProviderLogo src={this.providerLogo} />}
                                {this.typeFlow !== AAF_FLOW_PACKAGE && <Column lg={12}>
                                    {this.hasPlan && renderPrice(this.plan)}
                                    {this.hasPlan && <Heading size={3}>
                                        <span className={cls(`${DETAIl_S}-text-blue`)}>{getBonus(this.plan)}</span>
                                    </Heading>}
                                    <p className={cls(`${MAIN_CLASSNAME}-description`, `${DETAIl_S}-heading-top`)}>
                                        {this.description}
                                    </p>
                                </Column>}
                                {this.typeFlow === AAF_FLOW_GOOLE_POLICITY_ANDROID_TV && <AndroidTvPolicity labels={getAndroidTvPolicesLabels()} buttons={this.button} />}
                                {this.typeFlow === AAF_FLOW_CALL_CENTER && <CallCenterDetails plan={this.plan} family={this.family} />}
                                {this.typeFlow !== AAF_FLOW_PACKAGE && <Column lg={12} className={`${MAIN_CLASSNAME}-actions`}>
                                    {
                                        this.renderButtons(data)
                                    }
                                </Column>}
                                {
                                    this.typeFlow === AAF_FLOW_PACKAGE &&  <PlanSelectorComponent cardData={cardData} handleBlueButton={this.handleBlueButton} />
                                }
                            </Row>
                        </div>
                    </Grid>
                </ModalWrapper>
            );
        }
    };
}

ModalAddOn.propTypes = {
    user: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    playFullMedia: PropTypes.func.isRequired,
    pbi: PropTypes.object.isRequired,
    provider: PropTypes.string.isRequired,
    groupId: PropTypes.string.isRequired,
    backCallback: PropTypes.func,
}

ModalAddOn.defaultProps = {
    user: {}, // from mapStateToProps
    handleClose: () => { }, // from HOC
    playFullMedia: () => { }, // from mapDispatchToProps
    pbi: {},
    provider: '',
    groupId: '',
    backCallback: () => { }
}

const mapStateToProps = state => ({
    user: state.user,
});

const mapDispatchToProps = dispatch => ({
    playFullMedia: (pgm) => dispatch(playFullMedia(pgm))
  });


export default connect(mapStateToProps, mapDispatchToProps)(withOnClose(ModalAddOn));



// WEBPACK FOOTER //
// ./src/components/Modal/ModalAddOn.jsx